import React, { useMemo, useState } from 'react';
import Sidebar from './Sidebar';
import TopBar from './TopBar';

export default function AppLayout({ areaTitle, areaSubtitle, topCenter, navItems, topRight, children, hideSidebar, fullBleed }) {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const items = useMemo(() => navItems || [], [navItems]);

  const appClass = [
    'fr-app',
    collapsed ? 'fr-app--collapsed' : '',
    hideSidebar ? 'fr-app--noSidebar' : '',
    fullBleed ? 'fr-app--fullBleed' : ''
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={appClass}>
      {!hideSidebar ? (
        <Sidebar
          items={items}
          collapsed={collapsed}
          onToggleCollapse={() => setCollapsed((c) => !c)}
          mobileOpen={mobileOpen}
          onCloseMobile={() => setMobileOpen(false)}
        />
      ) : null}
      <TopBar title={areaTitle} subtitle={areaSubtitle} center={topCenter} onMobileMenu={() => setMobileOpen((o) => !o)} right={topRight} />
      <main className={fullBleed ? 'fr-main fr-main--fullBleed' : 'fr-main'}>
        {fullBleed ? children : <div className="fr-container">{children}</div>}
      </main>
    </div>
  );
}
